var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSub06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_949)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2148 14.9994C33.2148 13.2243 31.7757 11.7852 30.0006 11.7852C28.2254 11.7852 26.7863 13.2243 26.7863 14.9994V32.1423C26.7863 33.9175 28.2254 35.3566 30.0006 35.3566C31.7757 35.3566 33.2148 33.9175 33.2148 32.1423V14.9994ZM30.0006 47.1423C32.3675 47.1423 34.2863 45.2236 34.2863 42.8566C34.2863 40.4897 32.3675 38.5709 30.0006 38.5709C27.6336 38.5709 25.7148 40.4897 25.7148 42.8566C25.7148 45.2236 27.6336 47.1423 30.0006 47.1423Z",
    fill: "#F84343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.24545 13.1624L5.54452 14.5418C10.6707 6.44827 19.7048 1.07129 30.0002 1.07129C41.6802 1.07129 51.7368 7.99319 56.3041 17.9448C57.0447 19.5582 56.3371 21.4664 54.7236 22.2069C53.1104 22.9474 51.202 22.2397 50.4614 20.6264C46.9034 12.8734 39.0759 7.49986 30.0002 7.49986C22.0524 7.49986 15.0618 11.6219 11.0583 17.8501L13.9597 19.5909C14.7029 20.0369 15.1043 20.8865 14.9768 21.7438C14.8492 22.6011 14.2178 23.2971 13.377 23.5073L4.80553 25.6502C3.65741 25.9372 2.49398 25.2391 2.20694 24.091L0.064084 15.5196C-0.146123 14.6787 0.170871 13.7941 0.867251 13.2781C1.56363 12.7622 2.50226 12.7165 3.24545 13.1624ZM48.9421 42.1497L46.0403 40.4088C45.2971 39.9629 44.896 39.1132 45.0233 38.2559C45.151 37.3986 45.7823 36.7026 46.6231 36.4924L55.1946 34.3496C56.3427 34.0625 57.5063 34.7606 57.7934 35.9087L59.9363 44.48C60.1463 45.3209 59.8291 46.2054 59.1331 46.7214C58.4367 47.2374 57.4981 47.2833 56.7546 46.8371L54.4557 45.458C49.3296 53.5516 40.2956 58.9284 30.0002 58.9284C18.3202 58.9284 8.26367 52.0066 3.69624 42.0549C2.95575 40.4415 3.66337 38.5334 5.27674 37.7929C6.89014 37.0523 8.79836 37.76 9.53884 39.3734C13.0971 47.1264 20.9245 52.4999 30.0002 52.4999C37.948 52.4999 44.9384 48.3779 48.9421 42.1497Z",
    fill: "#FFCACF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSub06);
export default __webpack_public_path__ + "static/media/sub_06.5aaedb3bdf721749abfdb3466e6a02f4.svg";
export { ForwardRef as ReactComponent };